import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,HttpErrorResponse,HttpResponse } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable,throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Configuration } from '../../app.constants';
import {SlimLoadingBarService} from "ng2-slim-loading-bar";
import {GlobalErrorHandlerService} from '../ErrorHandler/global-error-handler.service';


class Name{
  private _mName: string;
  private _cName: string;

  getMethodName(): string{
      return this._mName;
  }

  setMethodName(value: string){
      this._mName = value
  }

  get getControllerName(): string{
      return this._cName;
  }

  set setControllerName(value: string){
      this._cName = value
  }
}


//http://192.168.0.253:82/api/BasicState/GetBasicStateList?StateID=0
@Injectable({
  providedIn: 'root'
})
export class DataAccessService { 
  private actionUrl: string;

  private _mName: string;
  private _cName: string;

  get getMethodName(): string{
      return this._mName;
  }

  public set setMethodName(value: string){
      this._mName = value
  }

  get getControllerName(): string{
      return this._cName;
  }

  public set setControllerName(value: string){
      this._cName = value
  }
 
  constructor(private http: HttpClient, private configuration: Configuration) {
      this.actionUrl = configuration.serverWithApiUrl + this.getControllerName + this.getMethodName;
  }

  public getAll<T>(): Observable<T> {
   
     this.actionUrl = this.configuration.serverWithApiUrl + this.getControllerName + this.getMethodName;
      return this.http.get<T>(this.actionUrl);
  }
  public getAllWithCondition<T>(id: string): Observable<T> {
    this.actionUrl = this.configuration.serverWithApiUrl + this.getControllerName + this.getMethodName;
     return this.http.get<T>(this.actionUrl + id);
 }
  /* public getAllWithObject<T>(itemToUpdate: any): Observable<T> {
    this.actionUrl = this.configuration.serverWithApiUrl + this.getControllerName + this.getMethodName;
    return this.http.get<T>(this.actionUrl, itemToUpdate )
  } */
  public getSingle<T>(id: string): Observable<T> {
    this.actionUrl = this.configuration.serverWithApiUrl + this.getControllerName + this.getMethodName;
      return this.http.get<T>(this.actionUrl + id);
  }

  public add<T>(itemToAdd: any): Observable<T> {
      //const toAdd = { ItemName: itemName };
      this.actionUrl = this.configuration.serverWithApiUrl + this.getControllerName + this.getMethodName;
      return this.http.post<T>(this.actionUrl, itemToAdd)
                     
  }

  public update<T>(itemToUpdate: any): Observable<T> {
    this.actionUrl = this.configuration.serverWithApiUrl + this.getControllerName + this.getMethodName;
      return this.http
          .post<T>(this.actionUrl, itemToUpdate);
  }

  /* public delete<T>(id: string): Observable<T> {
    this.actionUrl = this.configuration.serverWithApiUrl + this.getControllerName + this.getMethodName;
      return this.http.delete<T>(this.actionUrl + id);
  } */
  public delete<T>(itemToUpdate: any): Observable<T> {
    this.actionUrl = this.configuration.serverWithApiUrl + this.getControllerName + this.getMethodName;
    return this.http.post<T>(this.actionUrl, itemToUpdate);
  }
}


@Injectable({
  providedIn: 'root'
})
export class CustomInterceptor implements HttpInterceptor {
  constructor(private _loadingBar: SlimLoadingBarService,private globalErrorHandler : GlobalErrorHandlerService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // start our loader here
    this._loadingBar.start();

      if (!req.headers.has('Content-Type')) {
          req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
      }

      req = req.clone({ headers: req.headers.set('Accept', 'application/json') });
      //return next.handle(req);
      return next.handle(req).pipe(
         // tap(evt => {if (evt instanceof HttpResponse) {
        //   if(evt.body && evt.body.success)
        //       //this.toasterService.success(evt.body.success.message, evt.body.success.title, { positionClass: 'toast-bottom-center' });
        // }}),
        catchError( (error: HttpErrorResponse) => { 
           let errMsg = '';
           // Client Side Error
           if (error.error instanceof ErrorEvent) {        
             errMsg = `Error: ${error.error.message}`;
           } 
           else {  // Server Side Error
             errMsg = `Error Code: ${error.status},  Message: ${error.message}`;
           }
           
           this._loadingBar.complete();
           this.globalErrorHandler.handleError(error);
           return throwError(error);
         })
      );
  }
}
